import React from 'react';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { formatDate } from '@utils/date';

import { TAsset } from '@interfaces/assets/asset';

import { EOoklaDisplayTypes } from '@constants/ookla';

import styles from './MarkerShortInfo.module.scss';

interface IAssetInfoProps {
	asset: TAsset;
	typeContainerMinWidth: string;
	isAssetOwnerAvailable: boolean;
}

const AssetInfo = ({
	asset,
	typeContainerMinWidth,
	isAssetOwnerAvailable,
}: IAssetInfoProps) => {
	const {
		appliedOoklaFilters: {
			type,
			isOoklaInfo,
		},
		ooklaFilteredData: { assetRelatedData },
	} = useAppSelector(map);

	const isOoklaAvailable = (
		!!isOoklaInfo &&
		type === EOoklaDisplayTypes.colorRelatedAssets &&
		assetRelatedData[asset.assetId]
	);

	return (
		<>
			<div
				className={styles.markerType}
				style={{ minWidth: typeContainerMinWidth }}
			>
				<div className={styles.type}>
					{asset.assetType.assetTypeName}
				</div>
				<div className={styles.subtype}>
					{asset.assetSubType?.assetSubTypeName}
				</div>
			</div>
			{
				isAssetOwnerAvailable && (
					<div className={styles.assetOwner}>
						<span className={styles.fieldName}>Asset Owner: </span>
						<span data-testid='asset-owner-name'>{asset.owner.name}</span>
					</div>
				)
			}
			<div className={styles.assetId}>
				<span className={styles.fieldName}>Asset ID: </span>
				<span data-testid='asset-id'>{asset.assetId}</span>
			</div>
			{isOoklaAvailable && (
				<div className={styles.ooklaContainer}>
					<div className={styles.sectionTitle}>Ookla information</div>
					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Measured at: </span>
						<span className={styles.ooklaValue}>
							{formatDate(assetRelatedData[asset.assetId].measuredAt)}
						</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Operator: </span>
						<span className={styles.ooklaValue}>{assetRelatedData[asset.assetId].operator}</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>FID: </span>
						<span className={styles.ooklaValue}>{assetRelatedData[asset.assetId].fid}</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Technology: </span>
						<span className={styles.ooklaValue}>{assetRelatedData[asset.assetId].technology}</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Measurement: </span>
						<span className={styles.ooklaValue}>{assetRelatedData[asset.assetId].measurement}</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Measurement type: </span>
						<span className={styles.ooklaValue}>
							{assetRelatedData[asset.assetId].measurementType.title}
						</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Device: </span>
						<span className={styles.ooklaValue}>{assetRelatedData[asset.assetId].deviceType.title}</span>
					</div>

					<div className={styles.ooklaParameterContainer}>
						<span className={styles.fieldName}>Value: </span>
						<span className={styles.ooklaValue}>{assetRelatedData[asset.assetId].value}dB</span>
					</div>
				</div>
			)}
		</>
	);
};

export default AssetInfo;
